  
<template>
  <div class="buttons-bar">
    <ul>
      <li>
        <router-link to="/" :class="path === '/' ? 'active' : ''">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="35"
            height="40"
            viewBox="0 0 35 40"
          >
            <defs>
              <pattern
                id="pattern"
                preserveAspectRatio="none"
                width="100%"
                height="100%"
                viewBox="0 0 100 100"
              >
                <image
                  width="100"
                  height="100"
                  xlink:href="data:image/png;base64,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"
                />
              </pattern>
            </defs>
            <rect
              id="icons8-plataforma-petrolera-100"
              width="35"
              height="40"
              fill="url(#pattern)"
            />
          </svg>
          <span data-v-step="17">Projects</span>
        </router-link>
      </li>
      <li>
        <router-link
          to="/project/Design and operation for hydraulic fracturing, Well PE32 – Technical support"
          :class="path === '/project/Design and operation for hydraulic fracturing, Well PE32 – Technical support' ? 'active' : ''"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23.51"
            height="24"
            viewBox="0 0 23.51 24"
          >
            <g id="Stats" transform="translate(-0.327)">
              <path
                id="Fill_312"
                data-name="Fill 312"
                d="M4.325,7.5H.979A.991.991,0,0,1,0,6.5V1A.991.991,0,0,1,.979,0H4.325A.991.991,0,0,1,5.3,1V6.5A.991.991,0,0,1,4.325,7.5ZM1.959,2V5.5H3.344V2Z"
                transform="translate(2.286 13)"
                fill="#fff"
              />
              <path
                id="Fill_313"
                data-name="Fill 313"
                d="M4.325,14H.979A.991.991,0,0,1,0,13V1A.991.991,0,0,1,.979,0H4.325A.991.991,0,0,1,5.3,1V13A.991.991,0,0,1,4.325,14ZM1.959,2V12H3.344V2Z"
                transform="translate(9.43 6.5)"
                fill="#fff"
              />
              <path
                id="Fill_314"
                data-name="Fill 314"
                d="M4.325,20.5H.979A.991.991,0,0,1,0,19.5V1A.991.991,0,0,1,.979,0H4.325A.991.991,0,0,1,5.3,1V19.5A.991.991,0,0,1,4.325,20.5ZM1.959,2V18.5H3.344V2Z"
                transform="translate(16.574)"
                fill="#fff"
              />
              <path
                id="Fill_315"
                data-name="Fill 315"
                d="M22.531,2H.98A.988.988,0,0,1,0,1,.992.992,0,0,1,.98,0H22.531a.992.992,0,0,1,.98,1,.988.988,0,0,1-.98,1"
                transform="translate(0.327 22)"
                fill="#fff"
              />
            </g>
          </svg>
          <span>Dashboard</span>
        </router-link>
      </li>
      <li>
        <router-link
          to="/calendar"
          :class="path === '/calendar' ? 'active' : ''"
        >
          <svg
            id="calendario_1_"
            data-name="calendario (1)"
            xmlns="http://www.w3.org/2000/svg"
            width="23.51"
            height="24"
            viewBox="0 0 39.804 39.804"
          >
            <g id="Grupo_16347" data-name="Grupo 16347">
              <g id="Grupo_16346" data-name="Grupo 16346">
                <path
                  id="Trazado_2676"
                  data-name="Trazado 2676"
                  d="M35.139,3.11H33.273V0h-3.11V3.11H9.64V0H6.53V3.11H4.664A4.67,4.67,0,0,0,0,7.774V35.139A4.67,4.67,0,0,0,4.664,39.8H35.139A4.67,4.67,0,0,0,39.8,35.139V7.774A4.67,4.67,0,0,0,35.139,3.11Zm1.555,32.03a1.557,1.557,0,0,1-1.555,1.555H4.664A1.557,1.557,0,0,1,3.11,35.139V14.615H36.694Zm0-23.633H3.11V7.774A1.557,1.557,0,0,1,4.664,6.219H6.53v3.11H9.64V6.219H30.164v3.11h3.11V6.219h1.866a1.557,1.557,0,0,1,1.555,1.555Z"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Grupo_16349"
              data-name="Grupo 16349"
              transform="translate(5.628 17.82)"
            >
              <g
                id="Grupo_16348"
                data-name="Grupo 16348"
                transform="translate(0.372 -0.138)"
              >
                <rect
                  id="Rectángulo_16940"
                  data-name="Rectángulo 16940"
                  width="3"
                  height="3"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Grupo_16351"
              data-name="Grupo 16351"
              transform="translate(12.192 17.82)"
            >
              <g
                id="Grupo_16350"
                data-name="Grupo 16350"
                transform="translate(0 0)"
              >
                <rect
                  id="Rectángulo_16941"
                  data-name="Rectángulo 16941"
                  width="3"
                  height="3"
                  transform="translate(-0.192 -0.138)"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Grupo_16353"
              data-name="Grupo 16353"
              transform="translate(17.758 17.82)"
            >
              <g
                id="Grupo_16352"
                data-name="Grupo 16352"
                transform="translate(0 0)"
              >
                <rect
                  id="Rectángulo_16942"
                  data-name="Rectángulo 16942"
                  width="3"
                  height="3"
                  transform="translate(0.242 -0.138)"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Grupo_16355"
              data-name="Grupo 16355"
              transform="translate(24.385 17.82)"
            >
              <g
                id="Grupo_16354"
                data-name="Grupo 16354"
                transform="translate(0 0)"
              >
                <rect
                  id="Rectángulo_16943"
                  data-name="Rectángulo 16943"
                  width="3"
                  height="3"
                  transform="translate(-0.385 -0.138)"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Grupo_16357"
              data-name="Grupo 16357"
              transform="translate(29.95 17.82)"
            >
              <g
                id="Grupo_16356"
                data-name="Grupo 16356"
                transform="translate(0 0)"
              >
                <rect
                  id="Rectángulo_16944"
                  data-name="Rectángulo 16944"
                  width="3"
                  height="3"
                  transform="translate(0.05 -0.138)"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Grupo_16359"
              data-name="Grupo 16359"
              transform="translate(5.628 24.385)"
            >
              <g
                id="Grupo_16358"
                data-name="Grupo 16358"
                transform="translate(0.372 0.297)"
              >
                <rect
                  id="Rectángulo_16945"
                  data-name="Rectángulo 16945"
                  width="3"
                  height="3"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Grupo_16361"
              data-name="Grupo 16361"
              transform="translate(12.192 24.385)"
            >
              <g
                id="Grupo_16360"
                data-name="Grupo 16360"
                transform="translate(0 0)"
              >
                <rect
                  id="Rectángulo_16946"
                  data-name="Rectángulo 16946"
                  width="3"
                  height="3"
                  transform="translate(-0.192 0.297)"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Grupo_16363"
              data-name="Grupo 16363"
              transform="translate(17.758 24.385)"
            >
              <g
                id="Grupo_16362"
                data-name="Grupo 16362"
                transform="translate(0 0)"
              >
                <rect
                  id="Rectángulo_16947"
                  data-name="Rectángulo 16947"
                  width="3"
                  height="3"
                  transform="translate(0.242 0.297)"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Grupo_16365"
              data-name="Grupo 16365"
              transform="translate(24.385 24.385)"
            >
              <g
                id="Grupo_16364"
                data-name="Grupo 16364"
                transform="translate(0 0)"
              >
                <rect
                  id="Rectángulo_16948"
                  data-name="Rectángulo 16948"
                  width="3"
                  height="3"
                  transform="translate(-0.385 0.297)"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Grupo_16367"
              data-name="Grupo 16367"
              transform="translate(5.628 30.951)"
            >
              <g
                id="Grupo_16366"
                data-name="Grupo 16366"
                transform="translate(0.372 -0.268)"
              >
                <rect
                  id="Rectángulo_16949"
                  data-name="Rectángulo 16949"
                  width="3"
                  height="3"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Grupo_16369"
              data-name="Grupo 16369"
              transform="translate(12.192 30.951)"
            >
              <g
                id="Grupo_16368"
                data-name="Grupo 16368"
                transform="translate(-0.192 -0.268)"
              >
                <rect
                  id="Rectángulo_16950"
                  data-name="Rectángulo 16950"
                  width="3"
                  height="3"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Grupo_16371"
              data-name="Grupo 16371"
              transform="translate(17.758 30.951)"
            >
              <g
                id="Grupo_16370"
                data-name="Grupo 16370"
                transform="translate(0.242 -0.268)"
              >
                <rect
                  id="Rectángulo_16951"
                  data-name="Rectángulo 16951"
                  width="3"
                  height="3"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Grupo_16373"
              data-name="Grupo 16373"
              transform="translate(24.385 30.951)"
            >
              <g
                id="Grupo_16372"
                data-name="Grupo 16372"
                transform="translate(-0.385 -0.268)"
              >
                <rect
                  id="Rectángulo_16952"
                  data-name="Rectángulo 16952"
                  width="3"
                  height="3"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Grupo_16375"
              data-name="Grupo 16375"
              transform="translate(29.95 24.385)"
            >
              <g
                id="Grupo_16374"
                data-name="Grupo 16374"
                transform="translate(0 0)"
              >
                <rect
                  id="Rectángulo_16953"
                  data-name="Rectángulo 16953"
                  width="3"
                  height="3"
                  transform="translate(0.05 0.297)"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Grupo_16376"
              data-name="Grupo 16376"
              transform="translate(30.385 30.951)"
            >
              <g
                id="Grupo_16372-2"
                data-name="Grupo 16372"
                transform="translate(-0.385 -0.268)"
              >
                <rect
                  id="Rectángulo_16952-2"
                  data-name="Rectángulo 16952"
                  width="3"
                  height="3"
                  fill="#fff"
                />
              </g>
            </g>
          </svg>

          <!-- <font-awesome-icon style="color:white;font-size:25px" icon="calendar-alt" /> -->
          <span>Calendar</span>
        </router-link>
      </li>

      <li class="item-perfil-movil">
        <router-link
          to="/accountsettings"
          :class="path === '/accountsettings' ? 'active' : ''"
        >
          <div class="img-profile">
            <img :src="getUserLoged.PhotoProfile" alt="user-profile" />
          </div>
          <div class="item-perfil-name">
            {{ getUserLoged.name.split(" ")[0] }}
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    path: "/",
  }),
  computed: {
    ...mapGetters("UserManager", ["getUserLoged"]),
  },
  watch: {
    $route({ path }) {
      this.path = path;
    },
  },
  created() {
    this.path = this.$route.path;
  },
};
</script>

<style>
.buttons-bar ul {
  margin: 0;
  padding: 0 !important;
  list-style-type: none;
  display: flex;
  flex-direction: column;
}
.buttons-bar li {
  margin: 15px 0;
}
.buttons-bar ul li a {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: 0.5s;
}
.buttons-bar ul li a.active {
  box-shadow: 0px 5px 15px 0px rgba(172, 178, 193, 1);
  background: var(--seventh-color);
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  width: 116.29%;
  padding: 10px 0;
  transition: 0.5s;
}
.buttons-bar ul li a span {
  font-family: "Montserrat", sans-serif;
  font-weight: 300;
  font-size: 0.5rem;
  color: var(--second-color);
}
.item-perfil-movil {
  display: none;
}
/*=============================================
ESCRITORIO PEQUEÑO O TABLET VERTICAL (SM revisamos en 768px)
=============================================*/
@media (max-width: 991px) and (min-width: 768px) {
  .buttons-bar ul {
    width: 100%;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }
  .buttons-bar ul li a svg {
    width: 3rem;
    height: 3rem;
    margin-right: 2px;
  }
  .buttons-bar ul li a span {
    font-size: 0.9rem;
  }
  .buttons-bar ul li a.active {
    flex-direction: row;
    background: var(--seventh-color);
    border-radius: 20px;
    padding: 10px 5px;
    box-shadow: none;
  }
  .item-perfil-movil {
    display: block;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
  }
  .img-profile {
    width: 55px;
    height: 55px;
  }
  .img-profile img {
    width: 100%;
    border-radius: 100%;
  }
  .item-perfil-movil .item-perfil-name {
    text-align: center;
    font-family: "Montserrat", sans-serif;
    font-weight: 300;
    font-size: 0.9rem;
    color: var(--second-color);
  }
}
/*=============================================
MOVIL (XS revisamos en 320px)
=============================================*/
@media (max-width: 767px) {
  .buttons-bar ul {
    width: 100%;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }
  .buttons-bar ul li {
    margin: 5px;
  }
  .buttons-bar ul li a {
    transition: 1s;
  }
  .buttons-bar ul li a svg {
    width: 1.5rem;
    height: 1.5rem;
  }
  .buttons-bar ul li a.active {
    flex-direction: row;
    background: var(--seventh-color);
    border-radius: 20px;
    padding: 10px 5px;
    box-shadow: none;
    transition: 1s;
  }
  .item-perfil-movil {
    display: block;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
  }
  .img-profile {
    width: 30px !important;
    height: 30px !important;
  }
  .img-profile img {
    width: 100%;
    border-radius: 100%;
  }
  .item-perfil-movil .item-perfil-name {
    text-align: center;
    font-family: "Montserrat", sans-serif;
    font-weight: 300;
    font-size: 0.5rem;
    color: var(--second-color);
  }
}
</style>